import { IDesign } from '@/service/ts-definitions';
import { useCommit, useSelector } from '@/store/rootStore';

export function useProjectStore() {
  const commit = useCommit();
  const projectData = useSelector((state) => state.project.data);

  function setProject(project: IDesign) {
    commit({ type: 'project/setProject', payload: project });
  }

  return {
    setProject,
    projectData,
  };
}
